<app-admin-form *ngIf="settings && ctx && ctx.AdminAccesslevel > 15" [title]="'Service Management'" [object]="settings">

  @for (service of services | keyvalue; track service) {
  <app-admin-custom-control>
    @for (api of service.value | keyvalue; track api) {
    <app-admin-action-button [dividerKind]="-1" [label]="api.key" [labelCols]="3" (clickAction)="reloadApiService(api)"
      [buttonColor]="responses[api.key]=='busy'?'warning':responses[api.key]?.length>0?'danger':'success'">
      @if (responses[api.key]?.length > 0 && responses[api.key] != 'busy') {
      <ng-container afterButton><span class="text-danger ms-2"><i>{{ responses[api.key] }}</i></span></ng-container>
      }
      @if (responses[api.key] == 'busy') {
      <span><i class="fas fa-sync fa-spin"></i></span>
      } @else if (responses[api.key]?.length > 0) {
      <span><i class="fas fa-exclamation-triangle"></i></span>
      } @else {
      <span><i class="fas fa-badge-check"></i></span>
      }
      herladen
    </app-admin-action-button>
    }
  </app-admin-custom-control>
  }


</app-admin-form>